import { useEffect } from 'react'

/**
 * Блокировка скролла страницы под модалку — БЕЗ сброса/потери позиции.
 *
 * На этом проекте скролл живёт на `html` (documentElement), у `body` высота
 * 100%. Поэтому:
 *   - `body{overflow:hidden}` (старый способ) схлопывал высоту body до
 *     вьюпорта → scrollHeight html падал → scrollTop сбрасывался в 0 (модалка
 *     «вверху», после закрытия теряли место в списке);
 *   - `body{position:fixed;top:-scrollY}` (iOS-трюк) тоже ломал: при height:100%
 *     body становился высотой во вьюпорт, а top:-scrollY уводил весь контент за
 *     верх экрана → страница пустела.
 *
 * Правильно — лочить САМ скроллер (`html`) через `overflow:hidden`: это
 * отключает пользовательский скролл, но scrollTop и высота контента
 * сохраняются (проверено: позиция и контент на месте). Никаких сдвигов.
 *
 * Refcount модульного уровня → корректная работа ВЛОЖЕННЫХ модалок (CardModal
 * → Sheet → …): лок ставит первая, снимает последняя.
 */

let lockCount = 0
let savedOverflow = ''

export function useScrollLock(active: boolean) {
	useEffect(() => {
		if (!active) return
		if (lockCount === 0) {
			savedOverflow = document.documentElement.style.overflow
			document.documentElement.style.overflow = 'hidden'
		}
		lockCount += 1
		return () => {
			lockCount = Math.max(0, lockCount - 1)
			if (lockCount === 0) {
				document.documentElement.style.overflow = savedOverflow
			}
		}
	}, [active])
}
